import { render } from "./aboutus.vue?vue&type=template&id=40024627&scoped=true&ts=true"
import script from "./aboutus.vue?vue&type=script&lang=ts"
export * from "./aboutus.vue?vue&type=script&lang=ts"

import "./aboutus.vue?vue&type=style&index=0&id=40024627&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40024627"]])

export default __exports__